import { isNumber } from 'lodash-es'

import { FlightSliceSegments } from './types'

export function getFlightSliceEmissions(flightSlice: FlightSliceSegments): number {
	return (
		flightSlice.segments.reduce(
			(acc, seg) => (seg.emissions && isNumber(acc) ? acc + seg.emissions : undefined),
			0 as number | undefined,
		) ?? 0
	)
}

export function getFlightProductEmissions(flightProduct: { flights: FlightSliceSegments[] }): number | undefined {
	return flightProduct.flights.reduce(
		(acc, fl) => {
			const sliceEmissions = getFlightSliceEmissions(fl)
			return sliceEmissions && isNumber(acc) ? acc + sliceEmissions : undefined
		},
		0 as number | undefined,
	)
}
